import NtunaCTA from "../reusables/NtunaCTA";

const SolutionsNtunaCTAWorld = () => {
  return (
    <div className="section-spacing-100 no-padding-top world-bg">
      <NtunaCTA />
    </div>
  );
};

export default SolutionsNtunaCTAWorld;  
